import { createContext, useContext } from "react";
import useCompanyFilter from "../hooks/useCompanyFilter";

export const DEFAULT_FILTER_CONFIG = {
    tiers: false,
    status: false,
    executive: false,
    companies: false,
    dateRange: false,
};

const CompanyFilterContext = createContext(null);

export const CompanyFilterContextProvider = ({ children, filterConfig = DEFAULT_FILTER_CONFIG }) => {
    const filter = useCompanyFilter({ filterConfig });
    return (
        <CompanyFilterContext.Provider value={filter}>
            {children}
        </CompanyFilterContext.Provider>
    );
};

export const useCompanyFilterContext = () => useContext(CompanyFilterContext);
